/** @jsxImportSource @emotion/react */
import { ModalTransition } from 'components/modal-dialog';
import ModalDialog from 'components/modal-dialog/Modal';
import { Field, Form, validate } from 'components/form';
import Textfield from 'components/textfield';
import { RadioGroup } from '@atlaskit/radio';
import { css, jsx } from '@emotion/react';
import * as yup from 'yup';
import IBAN from 'iban';
import { FormattedMessage } from 'components/i18n';
import { BankAccount } from '../types';
import { bankAccountTypes } from '../messages';
import { ModalBody, ModalFooter, ModalHeader, ModalTitle } from "@atlaskit/modal-dialog";
import Button, { LoadingButton } from "@atlaskit/button";
import React from "react";
import Checkbox from '@atlaskit/checkbox';
import { useAuth } from "../../auth";

const CheckboxField =  (props: any) => <Checkbox {...props}  isChecked={props.checked}></Checkbox>;

interface Props {
  isOpen: boolean;
  onCancel: () => void;
  onSave: (bankAccount: BankAccount) => Promise<void>;
  isSaving: boolean;
  bankAccount?: BankAccount | null;
}

const bankAccountTypeOptions = [
  {
    name: 'type',
    value: 'checking_account',
    label: <FormattedMessage {...bankAccountTypes.checking_account} />,
  },
  {
    name: 'type',
    value: 'savings_account',
    label: <FormattedMessage {...bankAccountTypes.savings_account} />,
  },
];

const schema = yup.object({
  bankAccountNumber: yup
    .string(),
    // .test('is-iban', 'Must be a valid IBAN number', (value) =>
    //   IBAN.isValid(value||'')
    // )
    // .required('Required'),
  type: yup.string().required('Required'),
});

const BankAccountModal: React.FC<Props> = ({
  isOpen,
  isSaving,
  onSave,
  bankAccount,
  onCancel,
}) => {
  const isNew = !bankAccount;
  const type = bankAccount?.type
  const { isBookkeeper } = useAuth();
  return (
    <ModalTransition>
      {isOpen && (
        <Form<BankAccount>
          onSubmit={(values) => onSave(values)}
          initialValues={bankAccount || {}}
          validate={validate(schema)}
        >
          {({form, handleSubmit}) => (
            <ModalDialog
              onClose={() => onCancel()}
              width="small"
              autoFocus
              shouldScrollInViewport={false}
            >
              <ModalHeader><ModalTitle><FormattedMessage
                id="bank.BankAccountModal.title"
                defaultMessage="Bank account"
              /></ModalTitle></ModalHeader>
              <ModalBody>

              <form onSubmit={handleSubmit}>
                <Field
                  label={
                    <FormattedMessage
                      id="bank.BankAccountModal.bankAccountNumber"
                      defaultMessage="Account number"
                    />
                  }
                  name="bankAccountNumber"
                >
                  <Textfield
                    // isDisabled={!(isNew || (type === 'savings_account' && isBookkeeper))}
                    isDisabled={!isBookkeeper}
                    placeholder="NL00XXXX012345678"
                  />
                </Field>
                <Field
                  label={
                    <FormattedMessage
                      id="bank.BankAccountModal.bankCode"
                      defaultMessage="Bank code"
                    />
                  }
                  name="bankCode"
                >
                  <Textfield
                    isDisabled={!isBookkeeper}
                    placeholder="XXXX"
                  />
                </Field>
                <Field
                  label={
                    <FormattedMessage
                      id="bank.BankAccountModal.type"
                      defaultMessage="Type"
                    />
                  }
                  name="type"
                >
                  <RadioGroup options={bankAccountTypeOptions} />
                </Field>
                {isBookkeeper && !isNew && <Field
                  label={
                    <FormattedMessage
                      id="bank.BankAccountModal.active"
                      defaultMessage="Active"
                    />
                  }
                  type="checkbox"
                  name="isActive"
                  component={CheckboxField}
                />}
              </form>
              </ModalBody>
              <ModalFooter>
                <Button appearance="subtle" onClick={() => onCancel()}>
                  <FormattedMessage id='components.modals.delete.cancel' defaultMessage='Cancel'/>
                </Button>
                <LoadingButton appearance="primary" type="submit" onClick={()=>form.submit()} isLoading={isSaving}>
                  <FormattedMessage id='bank.BankAccountModal.save' defaultMessage='Save' />
                </LoadingButton>
              </ModalFooter>
            </ModalDialog>
          )}
        </Form>
      )}
    </ModalTransition>
  );
};

export default BankAccountModal;

// {/*<h5>Bank koppeling</h5>*/}
// {/*<p css={css`margin-top: ${gridSize() / 2}px;`}>AdministratieBox maakt gebruik van Klarna om automatisch je banktransacties op te halen. Dit moet elke 90 dagen verlengt worden</p>*/}
// {/*<Button css={css`margin-top: ${gridSize()*1}px;`}>*/}
// {/*  Activate bank connection*/}
// {/*</Button>*/}
